import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class ChunkErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    const resolvedError = this.unwrapError(error);

    if (this.isDynamicImportError(resolvedError)) {
      const lastReload = sessionStorage.getItem('chunk-error-reload');
      const now = Date.now();

      if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
        sessionStorage.setItem('chunk-error-reload', now.toString());
        window.location.reload();
        return;
      }
    }

    console.error(error);
  }

  // esbuild throws TypeError for failed dynamic imports (not ChunkLoadError like webpack)
  private isDynamicImportError(error: unknown): boolean {
    if (error instanceof TypeError) {
      return error.message.toLowerCase().includes('dynamically imported module');
    }
    return false;
  }

  // Zone.js wraps unhandled promise rejections
  private unwrapError(error: unknown): unknown {
    if (error && typeof error === 'object' && 'rejection' in error) {
      return (error as any).rejection;
    }
    return error;
  }
}
